import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import useAppDispatch from "../../hooks/useAppDispatch";
import { UserSubscriptionService } from "../../services/userSubscription.service";
import { setUserSubscription } from "../../store/userSubscription/userSubscriptionSlice";
import { IUserSubscriptionModel } from "../../models/UserSubscription";

export const useGetUserSubscriptionQuery = (userId: string | null) => {
  const dispatch = useAppDispatch();
  return useQuery<IUserSubscriptionModel | null, Error>({
    queryKey: [QUERY_CONSTANTS.GET_USER_SUBSCRIPTION, userId],
    queryFn: () =>
      UserSubscriptionService.getUserSubscriptionByUserId(userId).then((res) => {
        dispatch(setUserSubscription(res.data));
        return res.data;
      }),
    enabled: !!userId,
  });
};
